import React from 'react';

const PlainCard = ({ title, listKeyValue }) => {
  return (
    <div className='detail-card'>
      <h4 className='detail-card__title' title={title}>
        {title}
      </h4>

      <div className='detail-card__content'>
        {listKeyValue.map((item, index) => (
          <div key={index} className='detail-card__item'>
            <span className='detail-card__key'>
              {item.key}
            </span>

            <span
              className='detail-card__value'
              title={item.value}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PlainCard;
